import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyGenDocFlowConfigContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({
    providedIn: "root",
  })
  export class CompanyGenDocFlowConfigService extends BaseApiTemplateService<CompanyGenDocFlowConfigContainerModel> {
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "company-gen-doc-flow-configs";
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "company-gen-doc-flow-configs";
        this.httpClient = http;
      }
  }